<template>
  <b-modal :active.sync="showed" has-modal-card :can-cancel="['x']">
    <div class="card">
       <order-form :key="componentKey" :charts="charts"></order-form>
    </div>
  </b-modal>
</template>

<script>

import OrderForm from "./OrderForm"
import { EventBus } from '@/utils'

export default {
  name: 'ShopModal',
  components: {
    OrderForm
  },
  props: {
  },
  data: function () {
    return {
      loading: true,
      showed: false,
      charts: [],
      componentKey: null
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted: function(){
    let $this = this
    EventBus.$on("successPushOrder", () => {
      $this.showed = false
      this.$toast.open({
        message: $this.$i18n.t('checkout.order_compleate'),
        type: 'is-success',
        position: 'is-bottom'
      })
    })
    EventBus.$on("failedPushOrder", (err) => {
      this.$toast.open({
        message: $this.$i18n.t('notify.form_error'),
        type: 'is-danger',
        position: 'is-bottom'
      })
    })
  },
  methods: {
    show(charts){
      let $this = this
      $this.componentKey += 1;
      $this.charts = []
      charts.forEach(function(chart){
        $this.charts.push(chart)
      })
      $this.showed = true
    }
  }
}
</script>

<style scoped>
</style>